import { api } from '@/scripts/api';

export const GuidelinesAndRequirementsService = {
    getById(accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/guidelines-requirements/account/${accountId}?include=["GuidelineRequirementFileModel"]`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    post(payload, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/guidelines-requirements/account/${accountId}`;

            api
                .post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    patch(id, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/guidelines-requirements/${id}/account/${accountId}`;

            api.put(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },
}
